import React from 'react';
import moment from 'moment';

import userImage from 'resource/img/user-default.png';

export default function userOwner({ user, created_at }) {
  const _displayDate = () => {
    const date = moment(created_at);
    const currentDate = moment();

    if (currentDate.diff(date, 'days') === 1) {
      return '1 dia.';
    }

    if (currentDate.diff(date, 'days') > 1) {
      return `${currentDate.diff(date, 'days')} dias.`;
    }

    return `${currentDate.diff(date, 'hours')} horas.`;
  };

  return (
    <div className="flex-row align-center justify-start m-1">
      <img
        src={user.image ? user.image : userImage}
        className="img-circle"
        style={{ height: '40px', width: '40px' }}
        alt="Imagem do usuário que realizou a publicação"
      />
      <div className="article-item-user">
        <h5>{user.name}</h5>
        <small>Há {_displayDate()}</small>
      </div>
    </div>
  );
}
